<template>
  <UpsertRowWorkflowActionForm enable-row-id v-bind="$attrs" />
</template>

<script>
import UpsertRowWorkflowActionForm from '@grouper/modules/integrations/localGrouper/components/services/LocalGrouperUpsertRowServiceForm'

export default {
  name: 'LocalGrouperUpdateRowServiceForm',
  components: { UpsertRowWorkflowActionForm },
}
</script>
